"use strict";

export class TabSwitch {
    constructor(radioName = 'tab-parent') {
        this.radioName = radioName;
    }

    init() {
        if (document.readyState === 'loading') {
            window.addEventListener('DOMContentLoaded', () => this.checkHash());
        } else {
            this.checkHash();
        }

        window.addEventListener('hashchange', () => {
            this.checkHash();
        });

        window.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            if (!link) return;

            const url = new URL(link.href, window.location.href);
            if (url.pathname === window.location.pathname && url.hash) {
                const targetId = url.hash.replace('#', '');
                const targetRadio = document.getElementById(targetId);

                if (targetRadio && targetRadio.type === 'radio' && targetRadio.name === this.radioName) {
                    e.preventDefault();
                    history.pushState(null, null, url.hash);
                    this.checkHash();
                }
            }
        });
    }

    checkHash() {
        const hash = window.location.hash;
        if (!hash) return;

        const targetId = hash.replace('#', '');
        const targetRadio = document.getElementById(targetId);

        if (targetRadio && targetRadio.type === 'radio' && targetRadio.name === this.radioName) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}